import { Features } from 'generated/featureDefinitions'

interface Props {
  feature:
    | Features.shift_management_coverage_view
    | Features.shift_management_insights_panel
    | Features.shift_management_view_options
    | Features.shift_management_save_shift_toggle
}

type ReturnParams = {
  iconName: 'shift-check' | 'chart-line' | 'eye-visible' | 'save'
  from: 'coverage' | 'time_insights' | 'view_options' | 'shift_assignment_sidepanel'
}

export const getFeatureParams = ({ feature }: Props): ReturnParams => {
  switch (feature) {
    case Features.shift_management_coverage_view:
      return {
        iconName: 'shift-check',
        from: 'coverage',
      }

    case Features.shift_management_insights_panel:
      return {
        iconName: 'chart-line',
        from: 'time_insights',
      }

    case Features.shift_management_view_options:
      return {
        iconName: 'eye-visible',
        from: 'view_options',
      }

    case Features.shift_management_save_shift_toggle:
      return {
        iconName: 'save',
        from: 'shift_assignment_sidepanel',
      }
  }
}
